import { createSlice } from "@reduxjs/toolkit";
import { getAddConsumableList, editConsumable, deleteConsumable, getAllGroups, createConsumable, createGroup, getBillingRequests, generateConsumableQuotation, manualConsumablePayment } from "./AddConsumableThunk";

const initialState = {
  addConsumableListSuccess: null,
  addConsumableListErr: null,
  editConsumableSuccess: null,
  editConsumableErr: null,
  deleteConsumableSuccess: null,
  deleteConsumableErr: null,
  getAllGroupSuccess: null,
  getAllGroupErr: null,
  createConsumableSuccess: null,
  createConsumableErr: null,
  createGroupSuccess: null,
  createGroupErr: null,
  billingRequestsSuccess: null,
  billingRequestsErr: null,
  generateQuotationSuccess: null,
  generateQuotationErr: null,
  manualPaymentSuccess: null,
  manualPaymentErr: null,
  // Tracks which sessions already have a quotation generated (keyed by session id),
  // so the Collect Cash / Waive Off buttons keep showing after navigating away and back.
  quotationGeneratedSessionIds: {},
};

const addConsumableSlice = createSlice({
  name: "addConsumableSlice",
  initialState,
  reducers: {
    resetGetAddConsumableList(state) {
      state.addConsumableListSuccess = null;
      state.addConsumableListErr = null;
    },
    resetEditConsumable(state) {
      state.editConsumableErr = null;
      state.editConsumableSuccess = null;
    },
    resetDeleteConsumable(state) {
      state.deleteConsumableErr = null;
      state.deleteConsumableSuccess = null;
    },
    resetGetAllGroups(state) {
      state.getAllGroupErr = null;
      state.getAllGroupSuccess = null;
    },
    resetCreateConsumable(state) {
      state.createConsumableSuccess = null;
      state.createConsumableErr = null;
    },
    resetCreateGroup(state) {
      state.createGroupSuccess = null;
      state.createGroupErr = null;
    },
    resetGenerateQuotation(state) {
      state.generateQuotationSuccess = null;
      state.generateQuotationErr = null;
    },
    resetManualPayment(state) {
      state.manualPaymentSuccess = null;
      state.manualPaymentErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      //  GET LIST OF ADDITIONAL CONSUMABLE
      .addCase(getAddConsumableList.fulfilled, (state, action) => {
        state.addConsumableListSuccess = action.payload;
      })
      .addCase(getAddConsumableList.rejected, (state, action) => {
        state.addConsumableListErr = action.error.message;
      })
      //  UPDATE ADDITIONAL CONSUMABLE
      .addCase(editConsumable.fulfilled, (state, action) => {
        state.editConsumableSuccess = action.payload;
      })
      .addCase(editConsumable.rejected, (state, action) => {
        state.editConsumableErr = action.error.message;
      })
      //  DELETE ADDITIONAL CONSUMABLE
      .addCase(deleteConsumable.fulfilled, (state, action) => {
        state.deleteConsumableSuccess = action.payload;
      })
      .addCase(deleteConsumable.rejected, (state, action) => {
        state.deleteConsumableErr = action.error.message;
      })
      //  DELETE ADDITIONAL CONSUMABLE
      .addCase(getAllGroups.fulfilled, (state, action) => {
        state.getAllGroupSuccess = action.payload;
      })
      .addCase(getAllGroups.rejected, (state, action) => {
        state.getAllGroupErr = action.error.message;
      })
      //  CREATE ADDITIONAL CONSUMABLE
      .addCase(createConsumable.fulfilled, (state, action) => {
        state.createConsumableSuccess = action.payload;
      })
      .addCase(createConsumable.rejected, (state, action) => {
        state.createConsumableErr = action.error.message;
      })
      //  CREATE CONSUMABLES GROUPS
      .addCase(createGroup.fulfilled, (state, action) => {
        state.createGroupSuccess = action.payload;
      })
      .addCase(createGroup.rejected, (state, action) => {
        state.createGroupErr = action.error.message;
      })
      .addCase(getBillingRequests.fulfilled, (state, action) => {
        state.billingRequestsSuccess = action.payload;
        state.billingRequestsErr = null;
      })
      .addCase(getBillingRequests.rejected, (state, action) => {
        state.billingRequestsErr = action.error.message;
        state.billingRequestsSuccess = null;
      })
      //  GENERATE ADDITIONAL BILLING QUOTATION
      .addCase(generateConsumableQuotation.fulfilled, (state, action) => {
        state.generateQuotationSuccess = action.payload;
        state.generateQuotationErr = null;
        const sessionId = action.meta.arg?.id;
        if (sessionId) {
          state.quotationGeneratedSessionIds[sessionId] = true;
        }
      })
      .addCase(generateConsumableQuotation.rejected, (state, action) => {
        state.generateQuotationErr = action.error.message;
      })
      //  MANUAL PAYMENT (CASH / ABSCONDED)
      .addCase(manualConsumablePayment.fulfilled, (state, action) => {
        state.manualPaymentSuccess = action.payload;
        state.manualPaymentErr = null;
      })
      .addCase(manualConsumablePayment.rejected, (state, action) => {
        state.manualPaymentErr = action.error.message;
      });
  },
});
export const { resetGetAddConsumableList, resetEditConsumable, resetDeleteConsumable, resetGetAllGroups, resetCreateConsumable, resetCreateGroup, resetGenerateQuotation, resetManualPayment } = addConsumableSlice.actions;
export default addConsumableSlice.reducer;
